// İlk içe aktarım: zod şema kurulmadan önce JIT'siz çalışır (CSP `script-src 'self'`, eval yok; zod-config.ts).
import './shared/lib/zod-config.ts';
import '@ticarishift/ui/fonts';
import './styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { startErrorTracking } from '@ticarishift/error-tracking';
import { t } from '@ticarishift/i18n';
import { App } from './app/App.tsx';
import { restoreThemePreference } from './shared/theme/theme.ts';

// Tema ilk boyamada ortak `theme-init.js` ile kurulmuştur ("Sistem" dahil); burada "Sistem" tercihi işletim sisteminin
// değişikliğini izlemeye başlar. Oturum açılınca sunucudaki tercih uygulanır (shared/auth/session.tsx).
restoreThemePreference();

// Hata takibi (S62): DSN yalnız çalışma zamanında (`/app-config.json`) verilirse SDK tembel paketle iner; yoksa dışarı istek gitmez.
startErrorTracking('backoffice');

const root = document.getElementById('root');
if (!root) {
  throw new Error(t('common.system.rootMissing'));
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
